package br.com.htms.inspeccaocampo.ui.screens

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.material3.Card
import androidx.compose.material3.CardDefaults
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import br.com.htms.inspeccaocampo.data.FormTipo
import br.com.htms.inspeccaocampo.form.AppController

@Composable
fun SharedFormHubScreen(controller: AppController) {
    val authUser by controller.authUser.collectAsState()
    val hubForms = listOf(
        FormTipo.INSPECAO_CAMPO to "Checklist diário de campo com fotos, GPS e assinaturas (fluxo atual).",
        FormTipo.RELATORIO_ALOJAMENTO to "realizar parte 1 e 2",
        FormTipo.COMUNICACAO_OCORRENCIAS to "Acidente, incidentes e quase acidentes"
    ).filter { (tipo, _) ->
        authUser?.canAccessForm(tipo) != false
    }

    LazyColumn(
        modifier = Modifier.fillMaxSize(),
        contentPadding = PaddingValues(16.dp),
        verticalArrangement = Arrangement.spacedBy(12.dp)
    ) {
        item {
            Text(
                "Selecione o formulário",
                style = MaterialTheme.typography.titleLarge,
                fontWeight = FontWeight.Bold
            )
            Text(
                "Escolha o tipo de inspeção/relatório para preencher.",
                style = MaterialTheme.typography.bodyMedium,
                modifier = Modifier.padding(top = 4.dp, bottom = 8.dp)
            )
        }
        if (hubForms.isEmpty()) {
            item {
                Text(
                    "Nenhum formulário disponível para o seu tipo de perfil. Peça ao admin para ajustar TST/ADM.",
                    style = MaterialTheme.typography.bodyMedium
                )
            }
        }
        hubForms.forEach { (tipo, descricao) ->
            item {
                HubCard(
                    titulo = tipo.rotulo,
                    descricao = descricao,
                    onClick = { controller.abrirFormulario(tipo) }
                )
            }
        }
    }
}

@Composable
private fun HubCard(titulo: String, descricao: String, onClick: () -> Unit) {
    Card(
        onClick = onClick,
        modifier = Modifier.fillMaxWidth(),
        colors = CardDefaults.cardColors(containerColor = MaterialTheme.colorScheme.primaryContainer)
    ) {
        Column(Modifier.padding(16.dp), verticalArrangement = Arrangement.spacedBy(6.dp)) {
            Text(titulo, fontWeight = FontWeight.Bold, style = MaterialTheme.typography.titleMedium)
            Text(descricao, style = MaterialTheme.typography.bodyMedium)
            Text(
                "Abrir →",
                fontWeight = FontWeight.SemiBold,
                color = MaterialTheme.colorScheme.primary
            )
        }
    }
}
